import { render } from "./MembersPage.vue?vue&type=template&id=5fa5d7f6&scoped=true"
import script from "./MembersPage.vue?vue&type=script&lang=js"
export * from "./MembersPage.vue?vue&type=script&lang=js"

import "./MembersPage.vue?vue&type=style&index=0&id=5fa5d7f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa5d7f6"]])

export default __exports__